<template>
  <div class="tag-browser-field">
    <div>
      <div class="field-name">
        {{ field.value.displayName || field.value.name }}
      </div>
      <div class="entity-type">{{ entityTypeName }}</div>
    </div>
    <div class="actions">
      <icon v-if="copied" name="fa-check" color="primary" class="copied-icon" />
      <action-button
        class="hover-action copy-button"
        v-if="selectable && !copied"
        icon="fa-copy"
        color="muted"
        @click="copyClicked"
      />
      <action-button
        v-if="selectable"
        icon="fa-plus"
        color="secondary"
        @click="selectClicked"
      />
      <action-button
        v-if="navigable"
        icon="fa-angle-right"
        color="secondary"
        @click="navigateClicked"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import * as contentControlType from "@/constants/contentControlTypes";

export default {
  props: {
    field: {
      required: true,
    },
    graph: {
      required: true,
    },
    pathString: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      copied: false,
    };
  },
  computed: {
    ...mapState({
      currentPlaceholder: (state) => state.currentPlaceholder,
    }),
    entityTypeName: function () {
      return this.field.typeDisplayName();
    },
    navigable: function () {
      const fieldValue = this.field.value;
      if (fieldValue.isQueryResult) {
        return false;
      }

      if (fieldValue.type.kind === "calculated") {
        return false;
      }

      if (fieldValue.type.kind === "scalar") {
        return (
          fieldValue.indexer ||
          (fieldValue.queries && fieldValue.queries.length > 0)
        );
      }

      if (fieldValue.type.kind === "list") {
        return true;
      }

      return true;
    },
    selectable: function () {
      const fieldValue = this.field.value;
      if (fieldValue.type.kind === "scalar") {
        return (
          !this.currentPlaceholder ||
          this.currentPlaceholder.type !== contentControlType.TAG
        );
      }

      if (fieldValue.type.kind === "list") {
        if (this.currentPlaceholder) {
          return this.currentPlaceholder.path !== this.pathString;
        }

        return true;
      }

      if (fieldValue.isQueryResult && !fieldValue.type.kind !== "list") {
        return true;
      }

      return !this.navigable;
    },
  },
  watch: {
    copied: function (copied) {
      const vm = this;
      if (copied) {
        setTimeout(() => (vm.copied = false), 3000);
      }
    },
  },
  emits: ["navigate", "select", "copy"],
  methods: {
    navigateClicked: function () {
      this.logDebug("Navigating to field.", { field: this.field });
      this.$emit("navigate", this.field);
    },
    selectClicked: function () {
      this.logDebug("Selecting field.", { field: this.field });
      this.$emit("select", this.field);
    },
    copyClicked: function () {
      this.copied = true;
      this.logDebug("Copying field path.", { path: this.pathString });
      this.$emit("copy", this.pathString);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../_css/variables";

.tag-browser-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: $white;

  & > .actions {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

  & .hover-action {
    display: inline-block;
    visibility: hidden;
  }

  &:hover .hover-action {
    visibility: inherit;
  }

  & .field-name {
    font-weight: bold;
    overflow-wrap: break-word;
    word-break: break-all;
  }

  & .entity-type {
    font-size: 0.75rem;
    color: $secondary;
    overflow-wrap: break-word;
    word-break: break-all;
  }
}
</style>
